import { IEHRApis } from "./IEHRApis";
import {
    AlbusUrlConfigs,
    GET_PAST_SESSIONS,
    PATIENT_MEDICAL_PROFILE_URL,
    GET_TREATMENT_PLAN_TEMPLATES_URL,
    EHR_API_PREFIX
} from "./AlbusUrlConfigs";
import ApiUtils from "../utils/ApiUtils";
import { IPatientNotesOOC } from "../components/patient/PatientNotesOOCCard";
import { IConfigBasedPrescription } from "../models/patients/IConfigBasedPrescription";
import { EHRRequestMapper } from "./EHRRequestMapper";
import { ConfigConstants } from "../utils/AppConstants";
import ITreatmentPlanTemplateResponseObj, { ITreatmentPlanTemplateSaveObj } from "../models/ITreatmentPlanTemplateResponse";
import { IFetchScheduledInterventionsProgressRequest, IFetchScheduledInterventionsProgresssResponse, IFetchScheduledInterventionsRequest, IFetchScheduledInterventionsResponse } from "../models/IFetchScheduledInterventions";

const GET_PATIENT_ACTIVITIES_URL: string = EHR_API_PREFIX + "/patientLogging/activity-search"

export default class EHRApis implements IEHRApis {
    getSubSectionsRecommendations(userId: number, userType: string, speciality: string, contexts: string[]): Promise<any> {
        const url = AlbusUrlConfigs.getDoctorSubSectionsRecommendationsUrl();
        const contextQuery = contexts.map((item: string) => ({
            context: item,
            speciality,
            userId
        }));
        return ApiUtils.apiPostRequest(url, JSON.stringify(contextQuery));
    }

    getMedicalProfile(patientId: number, appointmentId: number, doctorType: string): Promise<any> {
        const url = AlbusUrlConfigs.getMedicalProfileUrl(patientId, appointmentId, doctorType);
        return ApiUtils.apiGetRequest(url);
    }

    savePatientMedicalProfile(patientId: number, configBasedPrescription: IConfigBasedPrescription, appointmentId: number, doctorType: string): Promise<any> {
        return ApiUtils.apiPostRequest(
            AlbusUrlConfigs.createSavePatientMedicalProfileUrl(patientId, appointmentId),
            JSON.stringify(EHRRequestMapper.getEHRSavePrescriptionRequestFromConfigBasedPrescription(configBasedPrescription)))
    }

    savePatientNotesOOC(patientId: number, patientNotesOOC: any): void {
        console.log("saving patient notes ooc" + JSON.stringify(patientNotesOOC) + " for patientId " + patientId.toString())
        let url = PATIENT_MEDICAL_PROFILE_URL + "/" + patientId.toString()
        ApiUtils.apiPostRequest(url, JSON.stringify({ newConfigData: { patientNotesOOC: patientNotesOOC } }))
    }

    getPatientNotesOOC = (patientId: number): Promise<IPatientNotesOOC[]> => {
        let url = GET_PAST_SESSIONS + "?patientId=" + patientId.toString() + "&subSectionKey=patientNotesOOC"
        return ApiUtils.apiGetRequest(url)

    }

    getTreatmentPlanTemplates = (userId: number, diagnosis: Array<string>): Promise<Array<ITreatmentPlanTemplateResponseObj>> => {
        const url = AlbusUrlConfigs.getDoctorTreatmentPlanTemplatesUrl(userId, diagnosis);
        return ApiUtils.apiGetRequest(url);
    }

    getAllTreatmentPlanTemplates = (userId: number): Promise<Array<ITreatmentPlanTemplateResponseObj>> => {
        const url = AlbusUrlConfigs.getDoctorAllTreatmentPlanTemplatesUrl(userId);
        return ApiUtils.apiGetRequest(url);
    }

    getTreatmentPlanTemplatesByName = (userId: number, query: string): Promise<Array<ITreatmentPlanTemplateResponseObj>> => {
        const url = AlbusUrlConfigs.getDoctorTreatmentPlanTemplatesByNameUrl(userId, query);
        return ApiUtils.apiGetRequest(url);
    }

    getTreatmentPlanTemplatesById = (templateId: string): Promise<ITreatmentPlanTemplateResponseObj> => {
        const url = AlbusUrlConfigs.getDoctorTreatmentPlanTemplatesByIdUrl(templateId);
        return ApiUtils.apiGetRequest(url);
    }

    deleteTreatmentPlan = (templateId: string): Promise<any> => {
        const url = AlbusUrlConfigs.getDoctorTreatmentPlanTemplatesByIdUrl(templateId);
        return ApiUtils.apiDeleteRequest(url, "");
    }

    saveTreatmentPlanTemplate = (template: ITreatmentPlanTemplateSaveObj): Promise<any> => {
        const url = ApiUtils.createApiUrl(GET_TREATMENT_PLAN_TEMPLATES_URL + "/add");
        return ApiUtils.apiPostRequest(url, JSON.stringify(template));
    }

    getSectionAllowed = (doctorType: string, sectionKey: string): Promise<any> => {
        const url = AlbusUrlConfigs.getSectionAllowedUrl(doctorType, sectionKey);
        return ApiUtils.apiHeadRequest(url);
    }

    fetchPatientActivities(patientId: number): Promise<any> {
        const url: string = GET_PATIENT_ACTIVITIES_URL;
        return ApiUtils.apiPostRequest(url, JSON.stringify({ 'patientId': patientId }))
    }

    getIntervantionsSummary(data: IFetchScheduledInterventionsProgressRequest, patientId: string): Promise<Array<IFetchScheduledInterventionsProgresssResponse>> {
        const url: string = AlbusUrlConfigs.getScheduledInterventionsProgress(patientId);
        return ApiUtils.apiPostRequest(url, JSON.stringify(data));
    }

    getScheduledInterventions(data: IFetchScheduledInterventionsRequest): Promise<Array<IFetchScheduledInterventionsResponse>> {
        const url: string = AlbusUrlConfigs.getScheduledInterventions();
        return ApiUtils.apiPostRequest(url, JSON.stringify(data));
    }
    getScheduledInterventionsHistory(patientId: string): Promise<Array<IFetchScheduledInterventionsResponse[]>> {
        const url: string = AlbusUrlConfigs.getScheduledInterventionsHistory(patientId);
        return ApiUtils.apiPostRequest(url, JSON.stringify({ patientId: parseInt(patientId) }));
    }
}

